// React
import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import AniLink from 'gatsby-plugin-transition-link/AniLink'

// Styles
import { ColorWhite } from '../../styles/color'
import { Theme, RoleProp } from '../../styles/SolutionThemes'

const TimingDuration = '0.25s'

const Link = styled(AniLink)`
  text-decoration: none;
`

const SolutionCard = styled.div`
  position: relative;
  cursor: pointer;
  overflow: hidden;
  min-width: 85px;
  ${props =>
    props.isSelected
      ? css`
          width: 160px;
          height: 160px;
          margin: 0px 6px;
          box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.15),
            0px 2px 4px rgba(0, 0, 0, 0.15);
          opacity: 1;
        `
      : css`
          width: 148px;
          height: 148px;
          margin: 6px 6px;
          box-shadow: none;
          opacity: 0.75;
        `}


  transition: width ${TimingDuration} ease-out, height ${TimingDuration} ease-out,
    margin ${TimingDuration} ease-out, opacity ${TimingDuration} ease-out;

  &:hover {
    & button {
      opacity: 1;
    }

    & svg {
      &.icon.white {
        & path,
        line,
        circle,
        polygon,
        polyline,
        rect {
          fill: ${props =>
            props.isSelected ? ColorWhite : props.theme.primaryColor};
          stroke: ${props =>
            props.isSelected ? ColorWhite : props.theme.primaryColor};

          &[fill='none'] {
            fill: none;
          }
        }
      }
    }
  }
`

const SolutionCardBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
      0deg,
      rgba(${props => props.theme.primaryColorRgb}, 0.3),
      rgba(${props => props.theme.primaryColorRgb}, 0.3)
    ),
    linear-gradient(360deg, rgba(0, 0, 0, 5e-5) 0%, rgba(0, 0, 0, 0.5) 100%),
    url(${props => props.theme.images.card}) no-repeat center center;
  background-size: cover;
`

const SolutionIcon = styled.div`
  position: relative;
  margin-top: ${props => (props.isSelected ? 46 : 43)}px;
  margin-bottom: 10px;
  text-align: center;
  transition: margin ${TimingDuration} ease-out;

  & svg {
    width: ${props => (props.isSelected ? 37 : 31)}px;
    height ${props => (props.isSelected ? 37 : 31)}px;
    transition: width ${TimingDuration}, height ${TimingDuration};
  }
`

const SolutionText = styled.p`
  position: relative;
  margin: 3px;
  text-align: center;
  text-transform: uppercase;
  white-space: pre-wrap;
  color: ${ColorWhite};
  line-height: 1.4;
`

export const SolutionCardWide = ({ isSelected, role }) => {
  const theme = Theme[role]

  return (
    <Link fade duration={0.7} to={role}>
      <SolutionCard isSelected={isSelected} theme={theme} data-cy={theme.hook}>
        <SolutionCardBackground theme={theme} />

        <SolutionIcon isSelected={isSelected}>{theme.icon({})}</SolutionIcon>

        <SolutionText className="font-small-regular uppercase">
          {theme.roleText.split(' ').join('\n')}
        </SolutionText>
      </SolutionCard>
    </Link>
  )
}

SolutionCardWide.propTypes = {
  isSelected: PropTypes.bool,
  role: RoleProp,
}
